import { type ResultOf, type VariablesOf, graphql } from 'gql.tada';

const CityCuisinesQuery = graphql(`
  query CityCuisines($id: Int!) {
    City(id: $id) {
      id
      popularCuisines {
        nodes {
          id
          title
          category
          image {
            basePath
          }
        }
      }
    }
  }
`);

export type QueryVariables = VariablesOf<typeof CityCuisinesQuery>;
export type QueryResult = ResultOf<typeof CityCuisinesQuery>;

export default CityCuisinesQuery;
